module.exports = __webpack_public_path__ + "static/media/pouce.a065c2f7.svg";